import { render } from "./DocumentDetails.vue?vue&type=template&id=60ab1c61&scoped=true"
import script from "./DocumentDetails.vue?vue&type=script&lang=js"
export * from "./DocumentDetails.vue?vue&type=script&lang=js"

import "./DocumentDetails.vue?vue&type=style&index=0&id=60ab1c61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ab1c61"]])

export default __exports__